/**
 * Extracted from sections/ns-video-highlight.liquid (inline <script> at line 235).
 * Config bridge: window.__nsVideoHighlightSections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsVideoHighlightSections = window.__nsVideoHighlightSections || {};
  function boot(nsSectionId, nsSettings) {
    (function () {
      var root = document.getElementById(`shopify-section-${nsSectionId}`);
      if (!root) return;
      var btn = root.querySelector('.ns-vhl__play-btn');
      var player = root.querySelector('.ns-vhl__player');
      if (!btn || !player) return;
      btn.addEventListener('click', function () {
        // <video-media> swaps the <template> for the real player during this same
        // click, so watch for the node rather than guessing at timing.
        // MutationObserver, NOT requestAnimationFrame: rAF does not fire in a
        // backgrounded or otherwise non-painting tab, which would leave focus
        // stranded on the button we are about to hide.
        var done = false;
        var observer = null;
        var timer = null;
        var handoff = function () {
          if (done) return;
          var target = player.querySelector('iframe, video');
          if (!target) return;
          done = true;
          if (observer) observer.disconnect();
          if (timer) clearTimeout(timer);
          target.focus({ preventScroll: true });
        };
        observer = new MutationObserver(handoff);
        observer.observe(player, { childList: true, subtree: true });
        // Stop watching even if the player never arrives (network failure).
        timer = setTimeout(function () {
          if (observer) observer.disconnect();
        }, 5000);
        handoff(); // in case the swap already happened synchronously
      }, { once: true });
    })();
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
